export default "__VITE_ASSET__78b8cac8__"